/* eslint-disable react/prop-types */
/* eslint-disable react/no-multi-comp */
/* eslint-disable react/no-array-index-key */

import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import Image from 'components/image';
import ContentWrapper from 'components/content-wrapper';
import cn from 'classnames';
import Icon from 'components/icon';

const HousingProjectImageGalleryCarousel = ({
  slides,
  initialId,
  nextButtonText,
  previousButtonText,
  infinite = false,
  embedded = false,
  onSlideChange = null,
  onEnlarge = null,
  eagerLoad = false
}) => {
  const [currentSlide, setCurrentSlide] = React.useState(initialId);
  const slider = React.useRef();

  function SampleNextArrow(props) {
    const { onClick } = props;
    return (
      <button
        disabled={!infinite && slides && currentSlide + 1 >= slides.length}
        aria-label={nextButtonText}
        onClick={onClick}
        className="housing-project-image-gallery-carousel__button-next"
      ></button>
    );
  }

  function SamplePrevArrow(props) {
    const { onClick } = props;
    return (
      <button
        disabled={!infinite && currentSlide <= 0}
        aria-label={previousButtonText}
        onClick={onClick}
        className="housing-project-image-gallery-carousel__button-prev"
      ></button>
    );
  }

  const settings = {
    dots: false,
    infinite: infinite,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: false,
    swipeToSlide: true,
    afterChange: current => {
      setCurrentSlide(current);
      if (onSlideChange) {
        onSlideChange(current);
      }
    },
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />
  };

  React.useEffect(() => {
    if (slider.current) {
      slider.current.slickGoTo(initialId, true);
      if (currentSlide !== initialId) {
        setCurrentSlide(initialId);
      }
    }
  }, [initialId]);

  return (
    <div
      className={cn('housing-project-image-gallery-carousel', {
        'housing-project-image-gallery-carousel--embedded': embedded
      })}
    >
      <ContentWrapper theme={ContentWrapper.themes.fullWidth}>
        {embedded && onEnlarge && (
          <button
            className="housing-project-image-gallery-carousel__enlarge"
            onClick={onEnlarge}
            aria-label="Forstørr bildegalleri"
          >
            <Icon name="drag-pan" />
          </button>
        )}
        <Slider ref={slider} {...settings}>
          {slides &&
            slides.length !== 0 &&
            slides.map((slide, index) => (
              <div
                key={index}
                className="housing-project-image-gallery-carousel__content"
                aria-hidden={embedded && onEnlarge ? 'true' : 'false'}
              >
                {embedded && index === currentSlide && (
                  <button
                    type="button"
                    className="housing-project-image-gallery-carousel__overlay-button"
                    aria-label="Forstørr bildegalleri"
                    tabIndex={-1}
                    onClick={() => {
                      if (slider.current?.innerSlider?.state?.animating) return;
                      onEnlarge?.();
                    }}
                  ></button>
                )}
                <div className="housing-project-image-gallery-carousel__image-container">
                  <Image
                    className="housing-project-image-gallery-carousel__image"
                    {...slide.image}
                    isObjectFitContain
                    theme="stretch"
                    eagerLoad={eagerLoad}
                  />
                </div>
              </div>
            ))}
        </Slider>
        {slides && slides.length > 0 && (
          <div className="housing-project-image-gallery-carousel__meta-wrapper">
            <div className="housing-project-image-gallery-carousel__meta">
              <div className="housing-project-image-gallery-carousel__counter">
                {currentSlide + 1 < 10 && 0}
                {currentSlide + 1}
                <span className="housing-project-image-gallery-carousel__counter-total">
                  /{slides.length < 10 && 0}
                  {slides.length}
                </span>
              </div>
              {slides[currentSlide]?.description && !embedded && (
                <div className="housing-project-image-gallery-carousel__description">
                  {slides[currentSlide].description}
                </div>
              )}
            </div>
          </div>
        )}
      </ContentWrapper>
    </div>
  );
};

HousingProjectImageGalleryCarousel.propTypes = {
  slides: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.exact(Image.propTypes),
      description: PropTypes.string
    })
  ),
  initialId: PropTypes.number,
  nextButtonText: PropTypes.string,
  previousButtonText: PropTypes.string,
  infinite: PropTypes.bool,
  embedded: PropTypes.bool,
  onSlideChange: PropTypes.func,
  onEnlarge: PropTypes.func
};

HousingProjectImageGalleryCarousel.propTypesMeta = {
  initialId: 'exclude'
};

export default HousingProjectImageGalleryCarousel;
